<template>
  <v-app v-if="articleInfoValue">
    <v-container fluid class="article-actions">
      <v-row>
        <v-col cols="12">
          <v-subheader>نام و نام خانوادگی</v-subheader>
        </v-col>
        <v-col cols="12">
          <v-text-field placeholder="نام" v-model="fullName" disabled></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-subheader>شماره تلفن ارسال کننده</v-subheader>
        </v-col>
        <v-col cols="12">
          <v-text-field
            placeholder="شماره تلفن"
            v-model="phoneNumber"
            disabled
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-subheader>موضوع</v-subheader>
        </v-col>
        <v-col cols="12">
          <v-text-field placeholder="موضوع" v-model="subject" disabled></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-subheader>ایمیل ارسال کننده</v-subheader>
        </v-col>
        <v-col cols="12">
          <v-text-field placeholder="ایمیل" v-model="email" disabled></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-subheader>متن پیام</v-subheader>
        </v-col>
        <v-col cols="12">
          <v-textarea 
            placeholder="متن پیام"
            v-model="description"
            disabled
            rows="10"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-subheader>تاریخ ثبت</v-subheader>
        </v-col>
        <v-col cols="12">
          <v-text-field placeholder="تاریخ ثبت" v-model="createDate" disabled></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center mb-3">
        <!-- <v-btn
          class="ml-4 white--text font-weight-bold indigo darken-4 white--text"
          @click="editHandler"
        >
          ثبت کردن
        </v-btn> -->
        <router-link to="/contact-form">
          <v-btn class="white--text font-weight-bold indigo lighten-2">
            انصراف
          </v-btn>
        </router-link>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import baseURL from "@/axios";
export default {
    created() {
      axios
        .get(`${baseURL}ContactUs/GetById?id=${this.$route.params.id}`)
        .then((res) => {
          // console.log(res.data);
          this.fullName = res.data.data.fullName;
          this.email = res.data.data.email;
          this.description = this.removeTags(res.data.data.description);
          this.phoneNumber = res.data.data.phoneNumber;
          this.subject = res.data.data.subject;
          this.createDate = res.data.data.createDate;
        });
    },

  data() {
    return {
      id: this.$route.params.id,
      fullName: "",
      subject: "",
      desscription: "",
      phoneNumber: null,
      createDate: null,
      email: "",
      address: "",
      bio: "",
      postalCode: "",
      geoDivisionId: "",
      state: {
        value: null,
        text: null,
      },
      states: [],
      city: {
        value: null,
        text: null,
      },
      cities: [],
      selectItem: "null",
    };
  },
  computed: {
    ...mapGetters(["tokenValue", "articleInfoValue", "itemList"]),
  },
  methods: {
    onFileSelected(event) {
      this.image = event.target.files[0];
    },
    async editHandler() {
      //   this.list.map((item) => {
      //     if (item.title == this.selectItem) {
      //       this.selectItem = item.id;
      //     }
      //   });
      await axios
        .post(
          `${baseURL}ContactUs/Add`,
          {
            fullName: this.fullName,
            subject: this.subject,
            description: this.description,
            email: this.email,
            phoneNumber: this.phoneNumber,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
        .then(() => {
          this.$router.push("/contact-form");
        });
    },
     removeTags(str) {
    if ((str === null) || (str === ''))
        return false;
    else
        str = str.toString();

    // Regular expression to identify HTML tags in
    // the input string. Replacing the identified
    // HTML tag with a null string.
    return str.replace(/(<([^>]+)>)/ig, '');
},
    async changeHandler() {
      await axios
        .get(`${baseURL}GeoDivision/GetById?id=${this.state}`)
        .then((res) => {
          res.data.data.children.map((item) => {
            this.cities.push({
              text: item.title,
              value: item.id,
            });
          });
        });
    },
  },
};
</script>

<style>
.article-actions {
  background: #ffffff;
  height: auto;
}
.v-input__control {
  direction: ltr;
}
.v-input__slot {
  flex-direction: row-reverse;
}
.v-application--wrap {
  min-height: auto !important;
}
.theme--light.v-input input {
  text-align: right;
}
</style>
